/* __next_internal_client_entry_do_not_use__ HeaderCart auto */ import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { linkHoverColor } from "@faire/retailer-visitor-shared/components/Header/Colors";
import { topNavEvent } from "@faire/retailer-visitor-shared/components/Header/Events";
import { IconWithCountBadge } from "@faire/retailer-visitor-shared/components/Header/icons/IconWithCountBadge";
import { HeaderIconContainer } from "@faire/retailer-visitor-shared/components/Header/styled";
import { HeaderLink } from "@faire/retailer-visitor-shared/components/Header/styled";
import { useCartItems } from "@faire/retailer-visitor-shared/hooks/cart/useCartItems";
import { useCartPrefetch } from "@faire/retailer-visitor-shared/hooks/cart/useCartPrefetch";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { TimingRecorder, TIMING_KEYS } from "@faire/retailer-visitor-shared/lib/actionLatencyTools";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { CartEmpty } from "@faire/web--source/slate/icons/foundation/CartEmpty";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import cart from "@faire/web-api--source/routes/www/cart";
import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";
var Container = styled.div.withConfig({
    componentId: "sc-2ed29eb8-0"
})([
    "display:flex;",
    "{padding:0;}",
    "{&:hover{svg{color:",
    ";}}}"
], HeaderLink, responsiveMediaQueries.canHover, linkHoverColor);
var HeaderCartBase = function(props) {
    var className = props.className, dataTestId = props.dataTestId;
    var isDesktopAndAbove = useViewport().isDesktopAndAbove;
    var totalBrandsInCartFormatted = useCartItems().totalBrandsInCartFormatted;
    var prefetchCart = useCartPrefetch();
    var retailerToken = useRetailer().retailerToken;
    var cartPageLink = cart();
    var onCartLinkMouseEnter = function() {
        return prefetchCart(cartPageLink);
    };
    var handleCartClick = function() {
        TimingRecorder.get().recordTime(TIMING_KEYS.VIEW_CART);
        topNavEvent("cart", retailerToken !== null && retailerToken !== void 0 ? retailerToken : "");
        if (!isDesktopAndAbove) {
            var _getWindowOrThrow_scrollTo, _getWindowOrThrow;
            (_getWindowOrThrow_scrollTo = (_getWindowOrThrow = getWindowOrThrow()).scrollTo) === null || _getWindowOrThrow_scrollTo === void 0 ? void 0 : _getWindowOrThrow_scrollTo.call(_getWindowOrThrow, {
                top: 0,
                behavior: "smooth"
            });
        }
    };
    return /*#__PURE__*/ _jsx(Container, {
        className: className,
        children: isDesktopAndAbove ? /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(HeaderLink, {
                "data-test-id": dataTestId,
                to: cartPageLink,
                onClick: handleCartClick,
                onMouseEnter: onCartLinkMouseEnter,
                style: {
                    height: "unset"
                },
                children: /*#__PURE__*/ _jsx(HeaderCartIcon, {
                    totalBrandsInCartFormatted: totalBrandsInCartFormatted
                })
            })
        }) : /*#__PURE__*/ _jsx(HeaderLink, {
            "data-test-id": dataTestId,
            onClick: handleCartClick,
            to: cartPageLink,
            children: /*#__PURE__*/ _jsx(HeaderCartIcon, {
                totalBrandsInCartFormatted: totalBrandsInCartFormatted
            })
        })
    });
};
export var HeaderCart = observer(HeaderCartBase);
var HeaderCartIcon = function(param) {
    var totalBrandsInCartFormatted = param.totalBrandsInCartFormatted;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _totalBrandsInCartFormatted_length;
    var brandCount = ((_totalBrandsInCartFormatted_length = totalBrandsInCartFormatted === null || totalBrandsInCartFormatted === void 0 ? void 0 : totalBrandsInCartFormatted.length) !== null && _totalBrandsInCartFormatted_length !== void 0 ? _totalBrandsInCartFormatted_length : 0) <= 3 ? totalBrandsInCartFormatted : strictLocalize({
        id: "Mx3jxN",
        defaultMessage: [
            {
                type: 0,
                value: "999+"
            }
        ]
    });
    return /*#__PURE__*/ _jsx(ExpandingHeaderIconContainer, {
        children: /*#__PURE__*/ _jsx(IconWithCountBadge, {
            icon: /*#__PURE__*/ _jsx(InvertedCart, {
                fontSize: "20px"
            }),
            count: brandCount
        })
    });
};
var InvertedCart = styled(CartEmpty).withConfig({
    componentId: "sc-2ed29eb8-1"
})([
    "transform:scaleX(-1);"
]);
var ExpandingHeaderIconContainer = styled(HeaderIconContainer).withConfig({
    componentId: "sc-2ed29eb8-2"
})([
    "width:100%;"
]);
